import type { Theme } from '@elliemae/ds-system';

const commonItemBackgroundStyle = (color: string, hoverColor: string, activeColor: string): string => `

  background: ${color};


  :active {
    background: ${activeColor};
  }
`;

export const getItemBackgroundStyle = (props: { theme: Theme; selected?: boolean; opened?: boolean }): string => {
  if (props.selected && !props.opened)
    return commonItemBackgroundStyle(
      props.theme.colors.brand[200],
      props.theme.colors.brand[200],
      props.theme.colors.brand[200],
    );

  return commonItemBackgroundStyle(
    props.theme.colors.neutral['000'],
    props.theme.colors.neutral['080'],
    props.theme.colors.brand[200],
  );
};
